export default __webpack_public_path__ + "static/media/cn.cc3cf1a7.svg";